import { CTABand, PageShell } from '../components/Chrome';

export function AboutPage() {
  return (
    <PageShell active="about" cta={<CTABand heading="Got a problem worth talking through?" />}>
      <section className="site-wrap section about-page">
        <div className="about-grid">
          <div className="about-copy">
            <div className="overline">About Byte-Size</div>
            <h1>A local problem-solver for small business.</h1>
            <p>Byte-Size started with one observation: nearly every great small business runs on heroic spreadsheets. Quotes in one tab, the roster in another, stock in a third — square pegs wedged into round holes, often held together by the one person who is not allowed to go on holiday.</p>
            <p>The strange part is that useful tools already exist for much of it. What is usually missing is someone who will sit down, understand how the business actually works, and connect the right pieces without turning it into an enterprise transformation program.</p>
            <p>I am Duncan. I have spent years solving technology problems across hundreds of locations, translating between people, systems and suppliers. Byte-Size is where I bring that experience to local businesses that need practical help without a full internal technology team.</p>
            <ul className="about-values">
              <li><span className="li-glyph" aria-hidden="true">▸</span><span>Plain answers over jargon</span></li>
              <li><span className="li-glyph" aria-hidden="true">▸</span><span>Useful fixes over unnecessary rebuilds</span></li>
              <li><span className="li-glyph" aria-hidden="true">▸</span><span>Teach, document and leave things better understood</span></li>
            </ul>
          </div>
          <figure className="about-photo">
            <img src="/assets/duncan.webp" alt="Duncan, founder of Byte-Size" width="1000" height="1500" />
            <figcaption>Duncan — founder and problem-solver at Byte-Size</figcaption>
          </figure>
        </div>
      </section>
    </PageShell>
  );
}
